import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { TimesheetsState } from '@/store/timesheets/types';
import state from '@/store/timesheets/state';
import mutations from '@/store/timesheets/mutations';
import actions from '@/store/timesheets/actions';
import getters from '@/store/timesheets/getters'

const Timesheets: Module<TimesheetsState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default Timesheets;
